import type {AppThunk} from '../../../actions/types'
import {restApi} from '../../../services/rest'
import type {ProjectId} from '../../../types'
import {isBuildStepSelectorEnabled} from '../../../utils/featureToggles'
import {truthy} from '../../../utils/guards'
import type {Refetchable} from '../../../utils/refetchable'
import {combineRefetchables} from '../../../utils/refetchable'
import {preloadBuildStepSelector} from '../BuildStepSelector/BuildStepSelector.preload'

export const preloadSelectBuildRunners =
  (projectId: ProjectId): AppThunk<Refetchable> =>
  dispatch =>
    combineRefetchables<unknown>(
      [
        isBuildStepSelectorEnabled && dispatch(preloadBuildStepSelector(projectId)),
        dispatch(restApi.endpoints.getAvailableRunners.initiate({projectId})),
      ].filter(truthy),
    )
